import { FC } from "react";
import { ModalConfig } from "../../../types/Components/Modal/ModalConfig";
import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
} from "@chakra-ui/react";
import ModalBodyOccurrenceAlertSan from "./ModalBodyOccurrenceAlertSan";
import OccurrenceAlertSanIndicatorField from "./OccurrenceAlertSanIndicatorField";

interface ModalOccurrenceAlertSanProps {
  control: any;
  modalConfig: ModalConfig;
}

const ModalOccurrenceAlertSan: FC<ModalOccurrenceAlertSanProps> = ({
  control,
  modalConfig,
}) => {
  const { isOpen, title = "", buttonTitle, closeModal } = modalConfig;
  const occurrences = control._formValues.row?.occurrences || [];

  const modalContentProps =
    control._formValues.row?.origin === "Sistema" ? { maxW: "80vw" } : {};

  return (
    <Modal isOpen={isOpen} onClose={closeModal} isCentered size="6xl">
      <ModalOverlay />
      <ModalContent {...modalContentProps}>
        <ModalHeader fontSize="xl" fontWeight="bold">
          {title}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb="4">
          <Flex direction="column" gap="8">
            <ModalBodyOccurrenceAlertSan control={control} />
            {occurrences.length > 0 && (
              <Stack gap="4">
                {occurrences.map((occurrence: any, index: number) => (
                  <OccurrenceAlertSanIndicatorField
                    key={occurrence?.indicator?.id || index}
                    indicator={occurrence?.indicator}
                    occurrence={occurrence}
                    index={index}
                  />
                ))}
              </Stack>
            )}
          </Flex>
        </ModalBody>
        <ModalFooter justifyContent="flex-start">
          <Button onClick={closeModal}>{buttonTitle}</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalOccurrenceAlertSan;
